var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{key:`diagram-like-btn-${_vm.diagram.fuid}`,class:[
  'diagram-like-btn',
  !_vm.diagram.likedByAuthenticatedUser ? 'revert-colors' : '',
],attrs:{"depressed":"","color":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLike(!_vm.diagram.likedByAuthenticatedUser)},"mouseout":function($event){return _vm.$emit('mouseout')}}},[_c('v-icon',{staticClass:"liked-icon",attrs:{"size":_vm.iconSize,"color":"white"}},[_vm._v("$heartIcon")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }